(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mix-reviews"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wmix:not([data-mix-ready])').forEach(function(root){
    root.dataset.mixReady='1';
    var wall=root.querySelector('.wmix__wall'); if(!wall) return;
    var cards=[].slice.call(wall.querySelectorAll('.wmix__card'));
    var fade=root.querySelector('.wmix__fade'), mw=root.querySelector('.wmix__more'), btn=root.querySelector('.wmix__btn');
    var step=parseInt(root.dataset.step)||9;
    var shown=parseInt(root.dataset.initial)||9;
    if(window.Shopify&&Shopify.designMode) shown=cards.length;
    function up(){
      cards.forEach(function(c,i){c.classList.toggle('is-hidden',i>=shown)});
      var done=shown>=cards.length;
      if(fade)fade.classList.toggle('off',done);
      if(mw)mw.classList.toggle('off',done);
    }
    up();
    if(btn)btn.addEventListener('click',function(){shown=Math.min(cards.length,shown+step);up()});
    document.addEventListener('shopify:block:select',function(e){
      if(root.contains(e.target)){shown=cards.length;up();}
    });
    /* reels: tap to play (mp4 inline with sound, youtube swaps to iframe) */
    function stopOthers(except){
      [].forEach.call(wall.querySelectorAll('.wmix__reel'),function(r){
        if(r===except)return;
        var v=r.querySelector('video'); if(v&&!v.paused){v.pause();v.muted=true;}
        var f=r.querySelector('iframe');
        if(f){
          f.remove();
          if(!r.querySelector('.wmix__play')){
            var nb=document.createElement('button');
            nb.type='button';nb.className='wmix__play';nb.setAttribute('aria-label','Play');
            nb.innerHTML='<svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.45)"/><path d="M9.5 7.5l7 4.5-7 4.5V7.5z"/></svg>';
            r.appendChild(nb);
          }
        }
      });
    }
    root.addEventListener('click',function(ev){
      var b=ev.target.closest('.wmix__play'); if(!b||!root.contains(b))return;
      var reel=b.closest('.wmix__reel');
      stopOthers(reel);
      var yt=reel.getAttribute('data-yt');
      if(yt){
        var f=document.createElement('iframe');
        f.src='https://www.youtube.com/embed/'+yt+'?autoplay=1&playsinline=1&rel=0';
        f.allow='autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen=true;
        reel.appendChild(f); b.remove();
        return;
      }
      var v=reel.querySelector('video');
      if(v){
        v.muted=false; v.playsInline=true;
        var p=v.play(); if(p&&p.catch)p.catch(function(){});
        b.remove();
        v.addEventListener('click',function(){ if(v.paused){v.play();} else {v.pause();} });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_review-cards"] && !Shopify.designMode) return;
  try {
    function wrevInit(){
  document.querySelectorAll('.wrev:not([data-rev-ready])').forEach(function(root){
    root.dataset.revReady='1';
    var wall=root.querySelector('.wrev__wall'); if(!wall) return;
    var cards=[].slice.call(wall.querySelectorAll('.wrev__card'));
    var fade=root.querySelector('.wrev__fade'), mw=root.querySelector('.wrev__more'), btn=root.querySelector('.wrev__btn');
    var step=parseInt(root.dataset.step)||6;
    var shown=parseInt(root.dataset.initial)||6;
    /* 7.10 Kfir: two rows, then fade and "See more". On a phone two rows of the 2-column wall is fewer cards (initial_count_m). */
    if(root.dataset.initialM&&window.matchMedia('(max-width: 749px)').matches) shown=parseInt(root.dataset.initialM)||shown;
    if(window.Shopify&&Shopify.designMode) shown=cards.length;
    function up(){
      cards.forEach(function(c,i){c.classList.toggle('is-hidden',i>=shown)});
      var done=shown>=cards.length;
      if(fade)fade.classList.toggle('off',done);
      if(mw)mw.classList.toggle('off',done);
    }
    up();
    // The body morph measures where each band sits once, at load. Load more makes this section
    // taller, so the bands below move down while the morph still uses their old place, and the
    // page went dark while the reader was still inside the reviews. It re-measures on resize.
    var toneT;
    if(btn)btn.addEventListener('click',function(){
      shown=Math.min(cards.length,shown+step);up();
      clearTimeout(toneT);toneT=setTimeout(function(){window.dispatchEvent(new Event('resize'));},80);
    });
    document.addEventListener('shopify:block:select',function(e){
      if(root.contains(e.target)){shown=cards.length;up();}
    });
  });
  }
  wrevInit();
  document.addEventListener('shopify:section:load',wrevInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ugc-wall"] && !Shopify.designMode) return;
  try {
    function wugcInit(){
  document.querySelectorAll('.wugc:not([data-ugc-ready])').forEach(function(root){
    root.dataset.ugcReady='1';
    // read before the first deal: the span sits inside the wall, and a deal empties the wall
    var lp=root.querySelector('[data-lib-pages]');
    var wrap=root.querySelector('.wugc__wrap');
    var wall=root.querySelector('.wugc__wall');
    if(!wrap||!wall) return;
    var fade=root.querySelector('.wugc__fade');
    var mw=root.querySelector('.wugc__more');
    var btn=root.querySelector('.wugc__btn');
    var mobile=window.matchMedia('(max-width: 749px)').matches;
    var step=parseInt(mobile?root.dataset.stepM:root.dataset.step)||480;
    var reveal=parseInt(mobile?root.dataset.revealM:root.dataset.reveal)||600;
    var open=root.dataset.open==='1'||(window.Shopify&&Shopify.designMode);
    // Count mode (1.10): only the first `shown` cards are dealt into the wall, the rest wait outside the page.
    function batchNow(){ var d=parseInt(root.dataset.batch,10)||0, m=parseInt(root.dataset.batchM,10)||0; return mobile&&m>0?m:d; }
    var batch=open?0:batchNow();
    var shown=batch>0?batch:Infinity;

    // ---- row-first masonry -------------------------------------------------
    // Keep the authored order once, then deal the cards across columns, each card into
    // whichever column is currently shortest. Card 1,2,3 land side by side at the top,
    // so a clip placed second in the editor shows up in the first row, not halfway down.
    var order=[].slice.call(wall.children).filter(function(n){return n.classList.contains('wugc__card')});
    // 18.10 review library: clips spread evenly through the wall (Kfir: never all the clips in the first row)
    var isLib=!!(root.querySelector('.wugc__filters')||root.hasAttribute('data-lib'));
    function mix(list){
      var mm=list.filter(function(c){ return c.querySelector('.wugc__media'); }), tt=list.filter(function(c){ return !c.querySelector('.wugc__media'); });
      if(!mm.length||!tt.length) return list;
      var every=Math.max(2,Math.round((mm.length+tt.length)/mm.length)), mixed=[], ti=0, mi=0;
      for(var q=0;mi<mm.length||ti<tt.length;q++){ if(q%every===1&&mi<mm.length) mixed.push(mm[mi++]); else if(ti<tt.length) mixed.push(tt[ti++]); else mixed.push(mm[mi++]); }
      return mixed;
    }
    if(isLib) order=mix(order);

    // A card's data-block is a per-render id with the template's own key after "__"
    // (AQXdnTnd3MTU4Wmdta__ugc_v_000). Only the suffix is stable across renders, so that is
    // what a saved order stores. Anything the saved list does not mention keeps its authored
    // place at the end, which is what makes newly added cards behave predictably.
    function keyOf(c){ var d=c.getAttribute('data-block')||''; var i=d.indexOf('__'); return i>-1?d.slice(i+2):d; }
    var saved=(root.dataset.cardOrder||'').split(/[^A-Za-z0-9_-]+/).filter(Boolean);
    if(saved.length){
      var byKey={}; order.forEach(function(c){ byKey[keyOf(c)]=c; });
      var sorted=[];
      saved.forEach(function(k){ if(byKey[k]){ sorted.push(byKey[k]); delete byKey[k]; } });
      order.forEach(function(c){ if(byKey[keyOf(c)]) sorted.push(c); });
      order=sorted;
    }
    function cols(){
      var cs=getComputedStyle(root);
      var w=window.innerWidth;
      var n;
      if(w<680)       n=parseInt(cs.getPropertyValue('--wugc-cols-m'),10)||2;
      else if(w<1040) n=parseInt(cs.getPropertyValue('--wugc-cols-t'),10)||3;
      else            n=parseInt(cs.getPropertyValue('--wugc-cols'),10)||4;
      return n<1?1:n;
    }
    function gapPx(){ return parseInt(getComputedStyle(wall).columnGap||getComputedStyle(wall).gap,10)||14; }
    // One cheap pass per card, cached, no DOM measurement.
    function estimate(card,colW){
      if(card._h&&card._w===colW) return card._h;
      var h=0, box=card.querySelector('.wugc__media');
      if(box){
        var ar=box.style.aspectRatio||'', m=ar.match(/([\d.]+)\s*\/\s*([\d.]+)/);
        var r=m?(parseFloat(m[1])/parseFloat(m[2])):(box.className.indexOf('--square')>-1?1:
               box.className.indexOf('--portrait')>-1?0.8:
               box.className.indexOf('--landscape')>-1?1.778:0.5625);
        if(r>0) h+=colW/r;
      }
      var tx=card.querySelector('.wugc__tx'), chars=tx?tx.textContent.length:0;
      var perLine=Math.max(18,colW/7.6);
      h += 74 + Math.ceil(chars/perLine)*22 + (card.querySelector('.wugc__rs')?22:0) + 34;
      card._w=colW; card._h=h;
      return h;
    }
    var dealtAt=0;
    var afterDeal=null;   // set by the video code below: a re-deal detaches every clip, which pauses it
    function deal(force){
      var n=cols();
      if(!force&&n===dealtAt&&wall.classList.contains('is-dealt')) return;
      dealtAt=n;
      wall.classList.add('is-dealt');
      wall.textContent='';
      var boxes=[],heights=[];
      for(var i=0;i<n;i++){
        var c=document.createElement('div'); c.className='wugc__col';
        wall.appendChild(c); boxes.push(c); heights.push(0);
      }
      // Height is ESTIMATED, never measured. Reading offsetHeight per card forces a synchronous
      // layout each time; at 400 cards that is 400 forced reflows per deal, and with clips
      // loading as you scroll it re-deals and pegs the main thread - the page stops scrolling.
      // We already know every card's media ratio (Liquid writes it, JS corrects it), so the
      // media height is arithmetic, and the body is close enough from the review length.
      var colW=(wall.clientWidth-(n-1)*gapPx())/n;
      order.filter(function(c){ return !c.hasAttribute('data-out'); }).forEach(function(card,idx){
        if(idx>=shown) return;
        var k=0; for(var j=1;j<n;j++){ if(heights[j]<heights[k]) k=j; }
        boxes[k].appendChild(card);
        heights[k]+=estimate(card,colW);
      });
      if(afterDeal) afterDeal();
    }
    // every clip and sound button, including the cards count mode keeps out of the page for now
    function all(sel){ var a=[]; order.forEach(function(c){ a.push.apply(a,c.querySelectorAll(sel)); }); return a; }
    deal();
    // 18.10 filter bar (review library): state and clicks live in the bar's own early script; here the wall re-deals
    if(root._fpaint){
      root._cards=order;
      var fapply=function(){ root._fpaint(); deal(true); if(typeof up==='function') up(); };
      root._wugcFilter=fapply; fapply();
    }

    // ---- drag to reorder, in the editor only --------------------------------
    // The block order lives in the template JSON, and nothing running in the storefront preview
    // can write to it. So the drag changes the order live and hands back the finished list to
    // paste into the wall's "Card order" box - honest about the one manual step rather than
    // pretending it saved.
    if(window.Shopify&&Shopify.designMode){
      root.classList.add('wugc--sortable');
      var bar=document.createElement('div');
      bar.className='wugc__bar';
      bar.innerHTML='<div><b>Order changed.</b> <small>Copy it, then paste into the wall\'s <b>Card order</b> box and save.</small></div>'+
                    '<button type="button" data-copy>Copy order</button>'+
                    '<button type="button" class="ghost" data-undo>Undo</button>';
      document.body.appendChild(bar);
      var start=order.slice(), drag=null, mark=null;

      function clearMark(){ if(mark){ mark.classList.remove('is-before','is-after'); mark=null; } }

      wall.addEventListener('dragstart',function(e){
        var c=e.target.closest&&e.target.closest('.wugc__card'); if(!c) return;
        drag=c; c.classList.add('is-dragging');
        e.dataTransfer.effectAllowed='move';
        try{ e.dataTransfer.setData('text/plain',keyOf(c)); }catch(_){}
      });
      wall.addEventListener('dragover',function(e){
        if(!drag) return;
        var c=e.target.closest&&e.target.closest('.wugc__card');
        if(!c||c===drag) return;
        e.preventDefault(); e.dataTransfer.dropEffect='move';
        var r=c.getBoundingClientRect(), after=(e.clientY-r.top)>r.height/2;
        if(mark!==c) clearMark();
        mark=c;
        c.classList.toggle('is-after',after);
        c.classList.toggle('is-before',!after);
      });
      wall.addEventListener('drop',function(e){
        if(!drag||!mark) return;
        e.preventDefault();
        var after=mark.classList.contains('is-after');
        var from=order.indexOf(drag); if(from>-1) order.splice(from,1);
        var to=order.indexOf(mark)+(after?1:0);
        order.splice(to,0,drag);
        clearMark(); drag.classList.remove('is-dragging'); drag=null;
        deal(true); up(); bar.classList.add('on');
      });
      wall.addEventListener('dragend',function(){
        clearMark();
        if(drag){ drag.classList.remove('is-dragging'); drag=null; }
      });
      // make them draggable only now, so the attribute never reaches a customer's page
      order.forEach(function(c){ c.setAttribute('draggable','true'); });

      bar.querySelector('[data-copy]').addEventListener('click',function(){
        var txt=order.map(keyOf).join(',');
        var done=function(){ var b=bar.querySelector('[data-copy]'); b.textContent='Copied'; setTimeout(function(){b.textContent='Copy order';},1600); };
        if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(txt).then(done,function(){ window.prompt('Copy this into "Card order":',txt); }); }
        else window.prompt('Copy this into "Card order":',txt);
      });
      bar.querySelector('[data-undo]').addEventListener('click',function(){
        order=start.slice(); deal(true); up(); bar.classList.remove('on');
      });
    }

    // ---- native ratios ------------------------------------------------------
    // A photo knows its shape in Liquid, so its card is already the right shape on first paint.
    // A video does not: it reports videoWidth/videoHeight only once metadata loads. Until then
    // the card holds a 9:16 placeholder. The moment the real shape arrives we stamp it on the
    // box and re-deal, so the clip sits in a card cut to its own ratio and nothing is cropped.
    // Re-dealing is debounced: 200 cards firing loadedmetadata would otherwise thrash the layout.
    // Nearly every card now arrives with its true ratio already in the markup, so a clip loading
    // should change nothing. Only a card whose ratio is genuinely wrong triggers a re-deal, the
    // debounce is long, and the whole thing gives up after a couple of passes: an endless
    // re-deal loop while the reader scrolls is exactly what froze the page.
    var rd, reflows=0;
    function reflow(){
      if(reflows>=2) return;
      clearTimeout(rd);
      rd=setTimeout(function(){ reflows++; deal(true); up(); },400);
    }
    all('.wugc__vid').forEach(function(v){
      v.addEventListener('loadedmetadata',function(){
        if(!v.videoWidth||!v.videoHeight) return;
        var box=v.parentNode;
        if(box.className.indexOf('wugc__media--')>-1) return;   // merchant pinned a shape, respect it
        var real=v.videoWidth/v.videoHeight;
        var cur=box.style.aspectRatio||'', m=cur.match(/([\d.]+)\s*\/\s*([\d.]+)/);
        var had=m?(parseFloat(m[1])/parseFloat(m[2])):0;
        if(had && Math.abs(had-real)/real < 0.02) return;       // already right: touch nothing
        box.style.aspectRatio=v.videoWidth+' / '+v.videoHeight;
        delete box.closest('.wugc__card')._h;
        reflow();
      });
    });

    function up(){
      if(open){
        wrap.classList.remove('is-clipped');
        wrap.style.maxHeight='';
        if(fade)fade.classList.add('off');
        if(mw)mw.classList.add('off');
        return;
      }
      if(batch>0){
        // count mode: whole cards, no clip; the button stays while cards are still waiting
        wrap.classList.remove('is-clipped');
        wrap.style.maxHeight='';
        // 8.10: "Fade the last row" keeps the fade over the bottom of the wall while cards are still waiting (off by default)
        // 18.10: count what the filter leaves, not the whole library, or an empty mix still offered Load more under a fade
        var left=order.filter(function(c){ return !c.hasAttribute('data-out'); }).length;
        if(fade)fade.classList.toggle('off',!(root.dataset.countFade==='1'&&shown<left));
        if(mw)mw.classList.toggle('off',shown>=left);
        return;
      }
      wrap.classList.add('is-clipped');
      wrap.style.maxHeight=reveal+'px';
      // the wall is fully shown once the clip passes its real height: drop the clip entirely
      // so nothing is cut off by a rounding error, and retire the fade and the button
      // 18.10 review library: a short filter result shows whole, but the wall must clip again when
      // the reader goes back to a big one, so it never latches open
      if(isLib){
        var whole=reveal>=wall.scrollHeight;
        wrap.classList.toggle('is-clipped',!whole); if(whole) wrap.style.maxHeight='';
        if(fade)fade.classList.toggle('off',whole);
        if(mw)mw.classList.toggle('off',whole);
        return;
      }
      if(reveal>=wall.scrollHeight){ open=true; up(); }
    }
    up();

    // The body morph measures where each band sits once, at load. Load more makes the wall taller,
    // so every band below it moves down while the morph still thinks it is where it was, and the
    // page turned dark while the reader was still inside the wall. The morph re-measures on
    // resize, so tell it once the height transition has finished.
    var toneT;
    function retone(){ clearTimeout(toneT); toneT=setTimeout(function(){ window.dispatchEvent(new Event('resize')); },620); }
    if(btn)btn.addEventListener('click',function(){
      /* 29.10 Kfir: "Show more reviews" must open more reviews and nothing else (he landed in the footer once).
         Remember where the reader is; if anything moves the page in the next 1.5 s without the reader scrolling, put it back. */
      var keepY=window.scrollY, userMoved=false;
      ['wheel','touchmove','keydown'].forEach(function(ev){ window.addEventListener(ev,function(){ userMoved=true; },{once:true,passive:true}); });
      [80,300,700,1300].forEach(function(ms){ setTimeout(function(){ if(!userMoved&&Math.abs(window.scrollY-keepY)>120) window.scrollTo({top:keepY,behavior:'instant'}); },ms); });
      if(batch>0){
        var first=order[shown];
        shown+=batch; deal(true); up(); retone();
        // keyboard and screen reader users land on the first new card, not back at the top
        if(first){ first.setAttribute('tabindex','-1'); try{ first.focus({preventScroll:true}); }catch(_){} }
        return;
      }
      reveal+=step; up(); retone();
    });

    var rt;
    window.addEventListener('resize',function(){
      clearTimeout(rt);
      rt=setTimeout(function(){
        var m=window.matchMedia('(max-width: 749px)').matches;
        if(m!==mobile){                       // crossing the breakpoint changes both budgets
          mobile=m;
          step=parseInt(m?root.dataset.stepM:root.dataset.step)||480;
          reveal=parseInt(m?root.dataset.revealM:root.dataset.reveal)||600;
        }
        deal(); up();
      },150);
    });

    // Shopify editor: never hide a block the merchant just selected
    document.addEventListener('shopify:block:select',function(e){
      if(root.contains(e.target)){ open=true; if(batch>0){ batch=0; shown=Infinity; deal(true); } up(); }
    });

    // ---- posters ------------------------------------------------------------
    // The poster is what the reader sees until a clip plays, and with autoplay off it is all they
    // see, so it must never be missing. The <img> is lazy (a poster attribute would load all of
    // them at once), and we promote it to eager a screen ahead so it is decoded before the card
    // scrolls in. If a poster fails, the card falls back to the clip's own first frame, fetched
    // only then and only as metadata.
    function firstFrame(v){
      if(v.src||!v.dataset.src) return;
      v.preload='metadata';
      v.src=v.dataset.src+'#t=0.1';
    }
    function wireVid(v){
      if(v._wj) return; v._wj=1;
      var box=v.parentNode, img=box.querySelector('.wugc__poster');
      // the poster hides only once the clip is really moving, never while it is still buffering
      v.addEventListener('playing',function(){ box.classList.add('is-playing'); });
      if(!img){ box.classList.add('no-poster'); return; }
      img.addEventListener('error',function(){ img.remove(); box.classList.add('no-poster'); firstFrame(v); });
    }
    all('.wugc__vid').forEach(wireVid);
    var pio=null;
    if('IntersectionObserver' in window){
      pio=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var box=en.target;
          pio.unobserve(box);
          var img=box.querySelector('.wugc__poster');
          if(img&&img.loading==='lazy') img.loading='eager';
          if(!img) firstFrame(box.querySelector('.wugc__vid'));
        });
      },{rootMargin:'900px 0px'});
      all('.wugc__vid').forEach(function(v){ pio.observe(v.parentNode); });
    }

    // media is only fetched once it is near the viewport, and only plays while it is on screen
    if(!('IntersectionObserver' in window)){
      all('.wugc__vid').forEach(function(v){ if(v.dataset.src)v.src=v.dataset.src; });
    }else{
      var wants=root.dataset.autoplay==='1';
      // A four-column wall puts a dozen or more clips on screen at once. Playing them all
      // saturates the decoder and the main thread, and the page stops scrolling - measured at
      // a 56 second blocking task on a 400 card wall. So only the clips nearest the middle of
      // the viewport actually play, and never more than a handful at a time. Everything else
      // holds its poster, which looks identical until you reach it.
      var MAX=window.matchMedia('(max-width: 749px)').matches?2:4;
      var playing=[];
      function stop(v){
        var i=playing.indexOf(v); if(i>-1) playing.splice(i,1);
        if(!v.paused) v.pause();
        v.parentNode.classList.remove('is-playing');
      }
      function start(v){
        if(!wants||playing.indexOf(v)>-1) return;
        if(playing.length>=MAX){
          // give the slot to whichever clip is nearest the centre of the screen
          var mid=window.innerHeight/2;
          var far=playing.reduce(function(a,b){
            return Math.abs(a.getBoundingClientRect().top-mid)>Math.abs(b.getBoundingClientRect().top-mid)?a:b;});
          if(Math.abs(far.getBoundingClientRect().top-mid)<=Math.abs(v.getBoundingClientRect().top-mid)) return;
          stop(far);
        }
        if(v.dataset.src&&!v.src) v.src=v.dataset.src;
        playing.push(v);
        var pr=v.play();
        if(pr&&pr.then) pr.then(function(){ v.parentNode.classList.add('is-playing'); },function(){ stop(v); });
      }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var v=en.target;
          if(en.isIntersecting) start(v); else stop(v);
        });
      },{rootMargin:'0px',threshold:.6});
      all('.wugc__vid').forEach(function(v){ io.observe(v); });
      // A clip that has played keeps its buffer and decoder even when paused. Reading down a
      // hundred-clip wall left ~100 loaded videos behind the reader, which is what makes an iPhone
      // tab stutter or reload. Once a clip is a couple of screens away, let it go: the poster is
      // still there, and it loads again if the reader comes back.
      var far=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting) return;
          var v=en.target;
          if(!v.getAttribute('src')) return;
          stop(v);
          v.removeAttribute('src');
          try{ v.load(); }catch(_){}
          if(pio&&v.parentNode.classList.contains('no-poster')) pio.observe(v.parentNode);
        });
      },{rootMargin:'1600px 0px'});
      all('.wugc__vid').forEach(function(v){ far.observe(v); });
      // A re-deal (a clip reporting its real shape, a breakpoint change) moves every card into new
      // columns. Moving a <video> pauses it, but it stayed booked in `playing`, so start() skipped
      // it forever and the observer never fired again because nothing changed on screen: the clip
      // froze. Release the slots and observe afresh, which re-reports whatever is on screen now.
      afterDeal=function(){
        playing.slice().forEach(stop);
        wall.querySelectorAll('.wugc__vid').forEach(function(v){ io.unobserve(v); io.observe(v); far.unobserve(v); far.observe(v); });
        if(pio) wall.querySelectorAll('.wugc__vid').forEach(function(v){
          var img=v.parentNode.querySelector('.wugc__poster');
          if(!v.src&&(!img||img.loading==='lazy')){ pio.unobserve(v.parentNode); pio.observe(v.parentNode); }
        });
      };
      // never let a backgrounded tab keep decoding
      document.addEventListener('visibilitychange',function(){
        if(document.hidden) playing.slice().forEach(stop);
      });
    }

    root.addEventListener('click',function(e){
        var b=e.target.closest('.wugc__sound'); if(!b||!root.contains(b)) return;
        var v=b.parentNode.querySelector('.wugc__vid'); if(!v) return;
        if(v.dataset.src&&!v.src) v.src=v.dataset.src;
        // is-playing is set by the clip's own 'playing' event: hiding the poster here showed a
        // grey box for as long as the clip took to buffer
        var on=b.getAttribute('aria-pressed')==='true';
        if(!on){
          // only one card makes noise at a time
          document.querySelectorAll('.wugc__vid').forEach(function(o){ if(o!==v)o.muted=true; });
          document.querySelectorAll('.wugc__sound').forEach(function(o){ if(o!==b){o.setAttribute('aria-pressed','false');o.setAttribute('aria-label','Unmute');} });
        }
        v.muted=on;
        b.setAttribute('aria-pressed',String(!on));
        b.setAttribute('aria-label',on?'Unmute':'Mute');
        if(v.paused){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
    });

    // 18.10 (Dror: "filters always work, no waiting for anything to load"): the wall and its filters
    // run at once on the first 250 reviews; the other pages come in quietly behind them and join
    // the END of the order, so what is already on screen never moves, and the current filter applies to them
    if(lp&&!root._libBusy){
      root._libBusy=1;
      Promise.all(lp.getAttribute('data-lib-pages').split('|').map(function(u){ return fetch(u).then(function(r){ return r.text(); }).catch(function(){ return ''; }); }))
        .then(function(htmls){
          var add=[];
          htmls.forEach(function(h){ if(!h) return; var d=new DOMParser().parseFromString(h,'text/html'); [].slice.call(d.querySelectorAll('.wugc__wall .wugc__card')).forEach(function(c){ add.push(document.importNode(c,true)); }); });
          if(!add.length) return;
          order=order.concat(mix(add));
          root._cards=order;
          add.forEach(function(c){ [].forEach.call(c.querySelectorAll('.wugc__vid'),wireVid); });
          if(root._fpaint) root._fpaint();
          deal(true); up(); retone();
        });
    }
  });
  }
  wugcInit();
  document.addEventListener('shopify:section:load',wugcInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_use-cards"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ucr--block:not([data-uc-ready])').forEach(function(root){
    root.setAttribute('data-uc-ready','');
    var track=root.querySelector('[data-uc-track]');
    var pillsWrap=root.querySelector('.ucr__pills');
    if(!track||!pillsWrap) return;
    var cards=[].slice.call(track.querySelectorAll('.ucr__card'));
    var pills=cards.map(function(c,i){
      var b=document.createElement('button');
      b.type='button'; b.className='ucr__pill'+(i===0?' is-on':''); b.setAttribute('data-i',i);
      var ic=c.getAttribute('data-icon');
      if(ic){var im=document.createElement('img');im.src=ic;im.alt='';im.width=20;im.height=20;b.appendChild(im);}
      var sp=document.createElement('span');sp.textContent=c.getAttribute('data-pill')||('Card '+(i+1));b.appendChild(sp);
      pillsWrap.appendChild(b);
      return b;
    });
    function setActive(i){pills.forEach(function(p,pi){p.classList.toggle('is-on',pi===i)})}
    function go(i){
      var c=cards[i]; if(!c) return;
      var padL=parseFloat(getComputedStyle(track).paddingLeft)||0;
      track.scrollTo({left:Math.max(0,c.offsetLeft-padL),behavior:'smooth'});
    }
    pills.forEach(function(p,i){p.addEventListener('click',function(){setActive(i);go(i)})});
    var st;
    track.addEventListener('scroll',function(){
      clearTimeout(st);
      st=setTimeout(function(){
        var center=track.scrollLeft+track.clientWidth/2, best=0, bd=1e9;
        cards.forEach(function(c,i){var cc=c.offsetLeft+c.clientWidth/2, d=Math.abs(cc-center); if(d<bd){bd=d;best=i}});
        setActive(best);
      },80);
    },{passive:true});
    root.__ucGoTo=function(i){if(i>=0&&i<cards.length){setActive(i);go(i);}};
  });
  } catch(e) { console.error(e); }
})();

})();
